<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25">
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      fill="#164194"
                      d="M0 5.592c0 2.15.487 4.2 1.358 6.072.905 1.943 2.222 3.69 3.863 5.153C6.863 18.28 8.825 19.452 11 20.258c2.175-.806 4.138-1.979 5.78-3.44 1.641-1.464 2.957-3.211 3.863-5.154C21.513 9.792 22 7.742 22 5.592c0-3.038-2.462-5.5-5.5-5.5-2.127 0-4.055.827-5.5 2.169C9.555.919 7.626.091 5.5.091 2.462.092 0 2.555 0 5.592z"
                      transform="translate(-157 -651) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 66) translate(1 2)"
                    />
                    <path
                      fill="#E1F5FE"
                      d="M1.833 5.592c0 .617.063 1.227.154 1.833l.418 1.834c.17.55.366 1.098.615 1.63.797 1.714 1.948 3.247 3.42 4.56 1.325 1.178 2.856 2.133 4.56 2.84 1.703-.707 3.236-1.662 4.56-2.84 1.142-1.018 2.086-2.174 2.827-3.44l.882-1.834c.583-1.477.898-3.013.898-4.583 0-2.022-1.645-3.667-3.667-3.667-1.576 0-3.087.596-4.253 1.68L11 4.761 9.752 3.604C8.586 2.521 7.076 1.925 5.5 1.925c-2.022 0-3.667 1.645-3.667 3.667z"
                      transform="translate(-157 -651) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 66) translate(1 2)"
                    />
                    <path
                      fill="#13A2E8"
                      d="M18.387 12.008h-3.611l-.516-2.32-1.33 5.987H9.99L8.25 7.855l-.923 4.154h-2.31l-.611-2.75H2.404l-.417-1.834h3.857l.312 1.404.72-3.237h2.749l1.834 8.25 1.426-6.417h2.75l.612 2.75h3.022l-.882 1.833z"
                      transform="translate(-157 -651) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 66) translate(1 2)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>